import { Badge } from "@loot-os/ui/components/badge";

/** live = primary, test = secondary — consistent everywhere a key/user/open mode shows up. */
export function ModeBadge({ mode }: { mode: "live" | "test" }) {
  return <Badge variant={mode === "live" ? "default" : "secondary"}>{mode}</Badge>;
}

/** Box lifecycle: active = primary, draft = secondary, archived = outline. */
export function StatusBadge({ status }: { status: "active" | "draft" | "archived" }) {
  const variant = status === "active" ? "default" : status === "draft" ? "secondary" : "outline";
  return <Badge variant={variant}>{status}</Badge>;
}

/** Product-fetch lifecycle: COMPLETE = primary, PENDING/PARTIAL = secondary, FAILED = destructive. */
export function FetchStatusBadge({ status }: { status: string }) {
  const variant =
    status === "COMPLETE" ? "default" : status === "FAILED" ? "destructive" : "secondary";
  return <Badge variant={variant}>{status}</Badge>;
}

/** Vendor listing lifecycle: ACTIVE = primary, INACTIVE = outline. */
export function ListingStatusBadge({ status }: { status: "ACTIVE" | "INACTIVE" }) {
  return <Badge variant={status === "ACTIVE" ? "default" : "outline"}>{status}</Badge>;
}
